import { InvoiceLine } from './invoiceLine';
import moment from 'moment';

export function DraftInvoice(data) {
  this.date = new Date();
  this.dateToNumber = null;
  this.createDate = null;
  this.modifiedDate = null;
  this.customer = null;
  this.isInvoice = true;
  this.companyErrors = [];
  this.relationErrors = [];
  this.invoiceErrors = [];

  const invoiceExceptionCodes = [11026, 11037, 11034, 11044, 11061, 11073];
  const companyExceptionCodes = [2007, 1043, 1044, 1045];
  const relationExceptionCodes = [11017, 11018, 11019, 11040, 11074];

  if (data) {
    if (typeof data.createDate === 'string') data.createDate = moment.utc(data.createDate).toDate();
    if (typeof data.modifiedDate === 'string')
      data.modifiedDate = moment.utc(data.modifiedDate).toDate();
    if (data.date && typeof data.date === 'string') data.date = moment.utc(data.date).toDate();
    if (data.dateToNumber && typeof data.dateToNumber === 'string')
      data.dateToNumber = moment.utc(data.dateToNumber).toDate();

    if (data.billingErrors) {
      try {
        var billingErrors = JSON.parse(data.billingErrors);

        if (billingErrors.length > 0) {
          billingErrors.map(error => {
            if (invoiceExceptionCodes.includes(error.code)) {
              this.invoiceErrors.push(error);
            }
            if (companyExceptionCodes.includes(error.code)) {
              this.companyErrors.push(error);
            }
            if (relationExceptionCodes.includes(error.code)) {
              this.relationErrors.push(error);
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    }

    angular.extend(this, data);
  }

  this.parseBillingErrors = function(billingErrors) {
    try {
      this.companyErrors = [];
      this.relationErrors = [];
      this.invoiceErrors = [];

      if (billingErrors.length > 0) {
        billingErrors.map(error => {
          if (invoiceExceptionCodes.includes(error.code)) {
            this.invoiceErrors.push(error);
          }
          if (companyExceptionCodes.includes(error.code)) {
            this.companyErrors.push(error);
          }
          if (relationExceptionCodes.includes(error.code)) {
            this.relationErrors.push(error);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  this.invoiceLines = null;

  this.isLoaded = function() {
    return this.invoiceLines != null;
  };

  this.addLine = function(line) {
    if (!this.isLoaded() || line == null) return;
    if (!(line instanceof InvoiceLine)) line = new InvoiceLine(line);
    this.invoiceLines.push(line);
  };
  this.deleteLine = function(lineId) {
    if (!this.isLoaded() || lineId == null) return;
    for (var i = 0; i < this.invoiceLines.length; i++) {
      if (this.invoiceLines[i].id === lineId) {
        this.invoiceLines.splice(i, 1);
        return;
      }
    }
  };

  this.findLine = function(lineId) {
    if (typeof lineId !== 'string') return null;
    for (var i = 0; i < this.invoiceLines.length; i++) {
      if (this.invoiceLines[i].id === lineId) {
        return this.invoiceLines[i];
      }
    }
    return null;
  };

  /* this.findRegistration = function(id) {
    if (typeof id !== 'string') return null;

    for (var i = 0; i < this.invoiceLines.length; i++) {
      if (!this.invoiceLines[i].hasRegistrations) continue;

      for (var j = 0; j < this.invoiceLines[i].registrations.length; j++) {
        if (this.invoiceLines[i].registrations[j].id !== id) continue;

        return {
          line: this.invoiceLines[i],
          registration: this.invoiceLines[i].registrations[j],
        };
      }
    }

    return null;
  };*/

  this.hasLineType = function(lineType) {
    if (!this.isLoaded()) return false;
    for (var i = 0; i < this.invoiceLines.length; i++)
      if (this.invoiceLines[i].type === lineType) return true;
    return false;
  };
  this.hasRegistrations = function() {
    if (!this.isLoaded()) return false;
    for (var i = 0; i < this.invoiceLines.length; i++)
      if (this.invoiceLines[i].hasRegistrations) return true;
    return false;
  };

  this.isAdvance = function() {
    return hasLineType(5);
  };

  this.hasErrors = function() {
    if (!!this.error) return true;
    if (this.companyErrors.length) return true;
    if (this.relationErrors.length) return true;
    if (this.invoiceErrors.length) return true;
    return false;
  };

  this.canNumber = function(ignoreDate) {
    if (this.hasErrors()) {
      if (this.invoiceErrors.length === 1) {
        // allow numbering for mollie warning
        if (this.invoiceErrors[0].code !== 11061) return false;
      } else {
        return false;
      }
    }
    if (this.invoiceLines != null && !this.invoiceLines.length) return false;
    if (!ignoreDate && this.dateToNumber !== null) return false;
    return true;
  };
}
